import { useState } from 'react';
import { AiOutlineMenu } from "react-icons/ai";
import { GrClose } from "react-icons/gr";
import DownloadCv from './DownloadCv';


const MobileNavBar = () => {
    const [expandedNavbar, setExpandedNavbar] = useState(false);
    return (
        <div
            className={`initial-scale-animation-navbar
            backdrop-blur-[5px] dark:bg-cDarkBG2/20 bg-white/50 text-gray-800 dark:text-cDarkText border border-white/10 xl:hidden overflow-hidden shadow-lg
            transition-all ease-in-out duration-300 mx-auto
            ${!expandedNavbar ? "h-[64px] rounded-2xl w-[calc(100vw-40px)]" : "h-[270px] rounded-lg w-[calc(100vw-30px)]"}
        `}>
            <div className='flex items-center justify-between py-2 px-5 h-[64px] shadow-lg border-b border-b-white/10'>
                <a href='/#about' className='animate-text bg-gradient-to-r from-teal-500 via-purple-500 to-orange-500 bg-clip-text text-transparent font-medium text-xl'>zamanShahed</a>

                <DownloadCv />

                <div className="flex items-center space-x-3">
                    {/* <div>
                        {isDarkMode ?
                            <WiDaySunny
                                onClick={() => {
                                    localStorage.setItem('color-theme', 'light');
                                    setIsDarkMode(false);
                                }}
                            />
                            : <MdDarkMode
                                onClick={() => {
                                    localStorage.setItem('color-theme', 'dark');
                                    setIsDarkMode(true);
                                }}
                            />
                        }
                    </div> */}
                    <div
                        onClick={() => setExpandedNavbar(!expandedNavbar)}
                        className={`
                    cursor-pointer transition-all ease-in-out duration-500
                    ${expandedNavbar ? "rotate-180" : "rotate-0"}
                `}>
                        {!expandedNavbar ? <AiOutlineMenu /> : <GrClose />}
                    </div>
                </div>
            </div>
            <LinksArea
                onLinkClick={()=>{setExpandedNavbar(false)}}
            />
        </div>
    )
}

export default MobileNavBar

const LinksArea = ({
    onLinkClick=()=>{}
}) => {
    return (
        <div className="pt-5">
            <div className='flex flex-col items-center justify-start font-normal space-y-2'>
                <a onClick={onLinkClick} href='/#about' className='hover:bg-cMainBG dark:hover:bg-cDarkMainBG cursor-pointer w-full pl-5 py-0.5'>About</a>
                <a onClick={onLinkClick} href='/#skills' className='hover:bg-cMainBG dark:hover:bg-cDarkMainBG cursor-pointer w-full pl-5 py-0.5'>Skills</a>
                <a onClick={onLinkClick} href='/#education' className='hover:bg-cMainBG dark:hover:bg-cDarkMainBG cursor-pointer w-full pl-5 py-0.5'>Education</a>
                <a onClick={onLinkClick} href='/#experience' className='hover:bg-cMainBG dark:hover:bg-cDarkMainBG cursor-pointer w-full pl-5 py-0.5'>Experience</a>
                <a onClick={onLinkClick} href='/#contributions' className='hover:bg-cMainBG dark:hover:bg-cDarkMainBG cursor-pointer w-full pl-5 py-0.5'>Contributions</a>
                {/* <a href='#' className='cursor-pointer'></a> */}
            </div>
        </div>
    )
}


{/* <a href='mailto:sumonshd@gmail.com' target={"blank"} className='cursor-pointer select-none text-3xl'>
        <HiMail />
    </a> */}